/**
 * Shared helpers for shop brands fetched from GET /api/brands.
 */

export const mapApiBrandToUi = brand => ({
  id: brand.id,
  brand: brand.name,
  value: brand.slug,
  logo_url: brand.logoUrl || null,
  url: brand.websiteUrl || null,
  logoOnDark: brand.logoOnDark === true,
  visible: brand.visible !== false,
  position: brand.position ?? 0,
});

export const brandsFromApiResponse = response => {
  const items = response?.items || response?.data?.items || [];
  return items.map(mapApiBrandToUi);
};
